import { Component, OnInit } from '@angular/core';
import { ShapeComponent } from '../shape/shape.component';
import { MousePosition, TextBox } from '../../models/shape';
import { ShapeType } from '../../models/shape-types';
import { DynamicForm } from '../../models/DynamicForm';


@Component({
  selector: 'app-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.css']
})
export class TextComponent extends ShapeComponent implements OnInit {

  dynamicForms: DynamicForm[];

  constructor() {
    super();
    console.log('TextComponent constructor');
    this.shape = new TextBox();
    this.shapeType = ShapeType.TextBox;
  }

  ngOnInit() {
    console.log('TextComponent ngOnInit');
  }

  updateShapeProperties(value: any) {
    console.log('TextComponent : updateShapeProperties');
    if (this.shape instanceof TextBox) {
      this.shape.shapeProperties.name = value.name;
      this.shape.text = value.text;
      this.shape.originX = value.x;
      this.shape.originY = value.y;
    }
  }

  setStyles() {
    let font: string = '';
    if (this.shape['isBold'] === true || this.shape['isBold'] === 'true')
      font += 'bold ';
    if (this.shape['isItalic'] === true || this.shape['isItalic'] === 'true')
      font += 'italic ';
    font += this.shape['textSize'] + 'px ' + this.shape['fontFamily'];
    let styles = {
      'fill': this.shape.shapeProperties.strokeColor,
      'font': font
    };
    return styles;
  }

  startDrawing(beginPosition: MousePosition): void {
    if (this.shape instanceof TextBox) {
      this.shape.originX = beginPosition.x;
      this.shape.originY = beginPosition.y;
    }
    console.log('TextComponent startDrawing at ', beginPosition, ', ', this.shape);

  }

}
